import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { Box, Sun, Moon } from 'lucide-react';

const SummaryHeader = () => {
  const { t } = useLanguage();
  const { isAdmin } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <div 
      className="mb-6 rounded-xl bg-surface p-6"
      style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        padding: '2rem'
      }}
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div
            className="logo-container"
            style={{
              width: 64,
              height: 64,
              borderRadius: '16px',
              background: 'linear-gradient(135deg, #0ea5e9 0%, #7c3aed 100%)',
              display: 'grid',
              placeItems: 'center',
              boxShadow: '0 4px 15px rgba(56, 189, 248, 0.4)'
            }}
          >
            <Box size={32} color="white" />
          </div>
          <div>
            <h2 style={{ margin: 0, color: 'white', fontWeight: 600, fontSize: '1.5rem' }}>{t('summaryDashboard')}</h2>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginTop: '0.5rem' }}>{t('widgetsPageSubtitle')}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={toggleTheme}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              border: '1px solid rgba(56, 189, 248, 0.3)',
              background: 'rgba(56, 189, 248, 0.1)',
              backdropFilter: 'blur(10px)',
              color: '#38bdf8',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontSize: '0.875rem',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            title={t('toggleTheme')}
          >
            {theme === 'light' ? <Moon size={16} /> : <Sun size={16} />}
          </button>
          <Link 
            to="/widgets" 
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              border: '1px solid rgba(56, 189, 248, 0.3)',
              background: 'rgba(56, 189, 248, 0.1)',
              backdropFilter: 'blur(10px)',
              color: '#38bdf8',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              fontSize: '0.875rem',
              fontWeight: 500
            }}
          >
            {t('widgets')}
          </Link>
          <Link 
            to="/servers" 
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              border: '1px solid rgba(56, 189, 248, 0.3)',
              background: 'rgba(56, 189, 248, 0.1)',
              backdropFilter: 'blur(10px)',
              color: '#38bdf8',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              fontSize: '0.875rem',
              fontWeight: 500
            }}
          >
            {t('servers')}
          </Link>
          {isAdmin && (
            <Link to="/users" className="btn btn-outline hover-lift">
              {t('users')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryHeader;